const React = require('react');
const withState = require('../../../utils/withState');
const {paramStore} = require("../../../stores");
const noop = require("mn-utils/noop");
const LayoutA = require("../Layout/A");
const TabsHeaderAdmin = require("./components/TabsHeaderAdmin");

const activeTabId$ = paramStore('activeTab');

const tabsCtor = (HeaderComponent) => withState(() => {
  return (state, {tabsData}) => {
    const activeId = state.activeTabId || Object.keys(tabsData)[0];

    const C = tabsData[activeId].component || noop;

    return (
      <LayoutA>
        <HeaderComponent
          tabsData={tabsData}
          activeId={activeId}
          setActiveId={(id) => {
            paramStore('s').emit('');
            activeTabId$.emit(id);
          }}
        />
        <div className="mt-75">
          <C />
        </div>
      </LayoutA>
    )
  }
}, {
  activeTabId: activeTabId$
});

module.exports = {
  AdminTabs: tabsCtor(TabsHeaderAdmin)
}
